import React, { Component } from 'react';
import * as actions from '../redux/time_off_actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { VirtualizedTable } from '../../common/VirtualizedTable/VirtualizedTable';
import { _filterTable } from '../../common/VirtualizedTable/virtualized-table-util';
import moment from 'moment-timezone';

class TimeOffRequestTable extends Component {
    constructor(props) {
		super(props);

        let columns = [{
            label: "Status",
            dataKey: "requestStatus",
            width: 350
        }, {
            label: "Dates",
            dataKey: "dateRange",
            width: 650
        }, {
            label: "Type",
            dataKey: "timeoffValue",
            width: 300
        }, {
            label: "Hours",
            dataKey: "totalHours",
            width: 350
        }, {
            label: "Submitted",
            dataKey: "dateCreated",
            width: 400
        }];

        this.state = {
            columns: columns,
            list: props.CurrentRequests ? props.CurrentRequests : [],
            filteredList: props.CurrentRequests ? props.CurrentRequests : []
        }  

        this.fetchTimeOffRequests();

        this.generateTypeFilter = this.generateTypeFilter.bind(this);
    }
    
    componentWillReceiveProps(nextProps) {
        let currReqs = JSON.stringify(this.props.CurrentRequests);
        let nextReqs = JSON.stringify(nextProps.CurrentRequests);
        if (currReqs !== nextReqs) {
            this.setState({
                list: nextProps.CurrentRequests,
                filteredList: nextProps.CurrentRequests
            });
        }
        if (this.props.User !== nextProps.User)
            this.fetchTimeOffRequests();
    }

    fetchTimeOffRequests() {
        let { User } = this.props;
        if (!User) return;
        var requestParams = {
            Page: 1,
            PageSize: 9999,
            SortOrder: 'desc',
            SortColumn: 'DateCreated',
            customFilters: [
                { "PropertyName": "AgentId", "Operation": 1, "Value": User.userID }
            ]
        }
        if(this.props.actions.fetchCurrentRequestsAction)
			this.props.actions.fetchCurrentRequestsAction(requestParams);
    }

    generateTypeFilter() {
        let types = this.props.TimeOffEnumItems;
        if (!types || types.length === 0) return null;
        return (
            <select
                className="time-off agent"
                onChange={(e) => _filterTable(e, "timeoffType", this)}>
                <option value="All">All</option>
                {
                    types.map((typeEnum, index) => <option key={index} value={typeEnum.key}>{typeEnum.value}</option>)
                }
            </select>
        );
    }
    
    render() {
        let { columns, filteredList } = this.state;
        let title = this.props.title ? this.props.title : "";
        return (
            <div className="table-container agent-time-off-request">
                <div className="status-container-title">{title}</div>
                { this.generateTypeFilter() }
                <VirtualizedTable
                    sortBy={"agentId"} 
                    columns={columns}
                    list={filteredList}
                    height={550}
                    width={500}
                    noRowsText={"Submit your first request."}
                    cellRenderer={({
                            cellData,
                            columnData,
                            columnIndex,
                            dataKey,
                            isScrolling,
                            rowData,
                            rowIndex
                        }) => {
                            let { RequestStatusEnumItems } = this.props;
                            if (dataKey === "requestStatus"
                                && RequestStatusEnumItems
                                && RequestStatusEnumItems.length > 0 ) {
                                let status = RequestStatusEnumItems.filter((item) => item.key === cellData)[0].value;
                                // let isFutureDate = rowData.dateRange.substr(6, 4) == (new Date()).getFullYear(); // Only == compare
                                let isFutureDate = moment(new Date(rowData.endDate)).isSameOrAfter(moment())

                                if ((status === "Pending")
                                || (status === "Approved" && isFutureDate))
                                    return (
                                        <div onClick={() => this.props.editTimeOffRequestOnClick(rowData, status)}>
                                            <div className="sp-portal edit-icon"></div>
                                            <div className="edit-field">{ status }</div>
                                        </div>
                                    );
                                return <div className="status-field">{ status }</div>;
                            }
                            if (dataKey === "totalHours")
                                return <div>{ cellData + " Hrs" }</div>;     
                            return <div>{ cellData }</div>;
                        }
                    }
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        User: state.common.user,
        CurrentRequests: state.timeoff.CurrentRequests,
        TimeOffEnumItems: state.timeoff.TimeOffEnumItems,
        RequestStatusEnumItems: state.timeoff.RequestStatusEnumItems
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TimeOffRequestTable);



// WEBPACK FOOTER //
// ./src/features/timeoff/TimeOff/TimeOffRequestTable.js